import { randomInRange } from '@mos/shared/utils'
import { EmitterConfig } from './emitter.config'

// Per-game tint exposed by the styles lib (theme's $particle-star-tint), read once (particles are spawned continuously)
let starTint: string | undefined
function particleStarTint(): string {
	if (starTint === undefined && typeof document !== 'undefined') {
		starTint =
			getComputedStyle(document.documentElement).getPropertyValue('--mos-particle-star').trim() || undefined
	}
	return starTint ?? '#66ffff'
}

export const ParticleStarUi: Partial<EmitterConfig> = {
	image: '/assets/scene/particles/star-glowing.png',
	size: 8,
	tint: () => particleStarTint(),
	initialAlpha: () => randomInRange(0.3, 0.8),
	ttl: () => randomInRange(1000, 2000),
}
export const ParticleStarPlain: Partial<EmitterConfig> = {
	image: '/assets/scene/particles/star-plain.png',
	size: 14,
}
export const ParticleStarDiffuse: Partial<EmitterConfig> = {
	image: '/assets/scene/particles/star-diffuse.png',
	size: 18,
}
export const ParticleStarGlowing: Partial<EmitterConfig> = {
	image: '/assets/scene/particles/star-glowing.png',
	size: 28,
}
export const ParticleStarDiffracted: Partial<EmitterConfig> = {
	image: '/assets/scene/particles/star-diffracted.png',
	size: 60,
}
